var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataFrame, Method, Status } from "lavva.exalushome/build/js/DataFrame";
import { ExalusConnectionService } from 'lavva.exalushome/build/js/Services/ExalusConnectionService';
import { Api } from 'lavva.exalushome';
import { DevicesService } from 'lavva.exalushome/build/js/Services/Devices/DevicesService';
import { WebApiCacheService } from 'lavva.exalushome/build/js/Services/WebApi/WebApiCacheService';
import { DependencyContainer } from "lavva.exalushome/build/js/DependencyContainer";
import { LoggerService } from "lavva.exalushome/build/js/Services/Logging/LoggerService";
import { IntercomConfiguration } from "./IWektaIntercomsService";
import { Intercom } from "./Intercom";
export class WektaIntercomsService {
    constructor() {
        this._connection = Api.Get(ExalusConnectionService.ServiceName);
        this._devices = Api.Get(DevicesService.ServiceName);
        this._cache = Api.Get(WebApiCacheService.ServiceName);
    }
    GetServiceName() {
        return WektaIntercomsService.ServiceName;
    }
    static Init() {
        DependencyContainer.Instance.RegisterService(new WektaIntercomsService());
        Api.Get(LoggerService.ServiceName).Debug(WektaIntercomsService.ServiceName, "Initialized WektaIntercomsService");
    }
    GetIntercomAsync(device) {
        return __awaiter(this, void 0, void 0, function* () {
            let cam = new Intercom();
            cam.SetDeviceChannel(device.Channels.first());
            return cam;
        });
    }
    GetIntercomConfigurationAsync(device) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this._connection.SendAndWaitForResponseAsync(new GetIntercomConfigurationRequest(device), 10000, false, true);
            switch (result.Status) {
                case Status.OK:
                    return result.Data;
                default:
                    throw new Error(`Failed to get camera configuration. Status: ${result.Status}.`);
            }
        });
    }
    CreateNewIntercomAsync(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this._connection.SendAndWaitForResponseAsync(new CreateNewIntercomRequest(data.RtspUrl, data.UserName, data.Password), 10000, false, true);
            switch (result.Status) {
                case Status.OK:
                    this._cache.ClearCache();
                    yield this._devices.GetDevicesAsync();
                    var cameraDeviceGuid = result.Data;
                    return this._devices.GetDevice(cameraDeviceGuid);
                default:
                    throw new Error(`Failed to create new camera. Status: ${result.Status}.`);
            }
        });
    }
    SetIntercomConfigurationAsync(device, configuration) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this._connection.SendAndWaitForResponseAsync(new UpdateIntercomDataRequest(device, configuration.RtspUrl, configuration.UserName, configuration.Password), 10000, false, true);
            if (result.Status == Status.OK) {
                this._cache.ClearCache();
                yield this._devices.GetDevicesAsync();
            }
            return result.Status;
        });
    }
}
WektaIntercomsService.ServiceName = "WektaIntercomsService";
class GetIntercomConfigurationRequest extends DataFrame {
    constructor(device) {
        super();
        this.Method = Method.Get;
        this.Resource = `/wekta/intercoms/get`;
        this.Data = device.Guid;
    }
}
class UpdateIntercomDataRequest extends DataFrame {
    constructor(device, url, user, password) {
        super();
        this.Method = Method.Put;
        this.Resource = "/wekta/intercom/upsert";
        this.Data = new IntercomConfiguration();
        this.Data.Guid = device.Guid;
        this.Data.RtspUrl = url;
        this.Data.UserName = user;
        this.Data.Password = password;
    }
}
class CreateNewIntercomRequest extends DataFrame {
    constructor(url, user, password) {
        super();
        this.Method = Method.Put;
        this.Resource = "/wekta/intercom/upsert";
        this.Data = new IntercomConfiguration();
        this.Data.RtspUrl = url;
        this.Data.UserName = user;
        this.Data.Password = password;
    }
}
//# sourceMappingURL=WektaIntercomsService.js.map